import { sendRequest } from './index';

export const faqService = () =>
	sendRequest({
		url: '/api/faq/v1/',
		method: 'GET'
	});

export const contactUsService = (payload) =>
	sendRequest({
		url: '/api/contact-us/v1/',
		method: 'POST',
		body: payload
	});
